
import React, { Component } from 'react';
import { ReactComponent as Back } from 'Icons/back.svg';
import { PAYMENT_TERMS, LINE_ITEM_DETAIL_DATE_FORMAT, HIKAL } from '../../constants/commonConstants';

import moment from 'moment';
import { RFQFTLTripsTable } from '../RFQFTLTripsTable/index';
import { RFQMultiModalTripsTable } from '../RFQMultiModalTripsTable/index';
import { RFQOtherTripsTable } from '../RFQOtherTripsTable/index';
import ClassName from 'classnames';
import { DEEPAK_PHENOLICS, CARGIL, PROVIDER_VALUE } from 'Constants/commonConstants';
import { getCompanyType } from 'Utils/storage';

export default class LineItemDetail extends Component {
   constructor(props) {
      super(props)
      this.state = {
         showCharges: false,
         leg: [],
      }
   }

   handleShowCharges = (show, leg) => {
      //  console.log("handleShowCharges ===>",show,leg)
      this.setState({
         leg: leg,
         showCharges: show
      })
   }

   onHCChange = (hcIndex, value, name) => {
      let newHeadingCharge = this.state.leg['multiModeHeadingCharges']
      newHeadingCharge[hcIndex][name] = value;
      this.setState({
         legs: {
            ...this.state.leg,
            multiModeHeadingCharges: newHeadingCharge,
         }
      });
   }

   update = (leg) => {
      this.setState({
         leg: {},
         showCharges: false
      })
   }

   render() {
      const { lineItem, paymentCycles, pricingBasis, hideLineItem, openLineItem, currencyTypes, rfq } = this.props;
      const isOtherType = [1, 4].indexOf(lineItem.rfqServiceType) === -1;

      const businessVolVal = lineItem.biddingDetails.businessVolumeValue ? lineItem.biddingDetails.businessVolumeValue : '';
      const businessVolUnit = lineItem.biddingDetails.businessVolumeUnitName ? lineItem.biddingDetails.businessVolumeUnitName : '';

      const tatVal = lineItem.biddingDetails.tatValue ? lineItem.biddingDetails.tatValue : '';
      const tatUnit = lineItem.biddingDetails.tatUnitName ? lineItem.biddingDetails.tatUnitName : '';

      const fromDate = lineItem.biddingDetails.from ? moment(lineItem.biddingDetails.from).format(LINE_ITEM_DETAIL_DATE_FORMAT) : '';
      const toDate = lineItem.biddingDetails.to ? (' to ' + moment(lineItem.biddingDetails.to).format(LINE_ITEM_DETAIL_DATE_FORMAT)) : '';

      let multiModedataFields = [];
      let multiModePriceFields = [];
      let totalChargableWeight = 0, totalGrossWeight = 0, totalNetWeight = 0, totalVolumeWeight = 0;
      let vehicleSpecificDetails = [];
      if(lineItem && lineItem.rfqType === 6) {
         const contractFrom = lineItem.contractTenureFrom ? moment(lineItem.contractTenureFrom).format(LINE_ITEM_DETAIL_DATE_FORMAT) : '';
         const contarctTo = lineItem.contractTenureTo ? (' to ' + moment(lineItem.contractTenureTo).format(LINE_ITEM_DETAIL_DATE_FORMAT)) : '';
         if(lineItem.providerType === 2 && lineItem.legName !== 'Yard To Yard (BCN)') {
            multiModedataFields = [
               {
                  label: 'Trip',
                  value: <span>
                     {lineItem.ftlStops.map((stop, index) => {
                        if(stop) {
                           return (
                              <span> {stop.city || stop.location || ''}
                                 {index !== lineItem.ftlStops.length - 1 && lineItem.ftlStops[index + 1] &&  <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />} </span>
                           )
                        }
                     })}
                  </span>
               },
               {
                  label: 'Vehicle',
                  value: <span> {lineItem.vehicleTypeName} <span className="fRegular"> {lineItem.vehicleBodyTypeName} </span>  </span>
               },
               {
                  label: 'Vehicle Body Type',
                  value: lineItem.vehicleBodyTypeName
               },
               {
                  label: 'Bidding',
                  value: fromDate + toDate
               },
               {
                  label: 'Contract Tenure',
                  value: contractFrom + contarctTo
               },
               {
                  label: 'Remarks',
                  value: lineItem.multiModeRemarks
               },
            ]
         } else if(lineItem.legName === 'Yard To Yard (BCN)') {
            multiModedataFields = [
               {
                  label: 'Trip',
                  value: <span>
                     {lineItem.ftlStops.map((stop, index) => {
                        if(stop) {
                           return (
                              <span> {stop.city || stop.location || ''}
                                 {index !== lineItem.ftlStops.length - 1 && lineItem.ftlStops[index + 1] && <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />} </span>
                           )
                        }
                     })}
                  </span>
               },
               {
                  label: 'Bidding',
                  value: fromDate + toDate
               },
               {
                  label: 'Commodity',
                  value: lineItem.commodityCategory + " - " + lineItem.commodityName
               }
            ]

            multiModePriceFields = [
               {
                  label: 'leg Type',
                  value: lineItem.legName
               },
               {
                  label: 'Tarrif Lines',
                  value: lineItem.tarrifLines
               },
               {
                  label: 'Wagon Type',
                  value: lineItem.wagonType
               }
            ]

         } else {
            multiModedataFields = [
               {
                  label: 'Trip',
                  value: <span>
                     {lineItem.ftlStops.map((stop, index) => {
                        if(stop) {
                           return (
                              <span> {stop.city || stop.location || ''}
                                 {index !== lineItem.ftlStops.length - 1 && lineItem.ftlStops[index + 1] && <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />} </span>
                           )
                        }
                     })}
                  </span>
               },
               {
                  label: 'Bidding',
                  value: fromDate + toDate
               },
               {
                  label: 'Contract Tenure',
                  value: contractFrom + contarctTo
               },
               {
                  label: 'Remarks',
                  value: lineItem.multiModeRemarks
               },
            ]
         }
         if(lineItem.legName !== 'Yard To Yard (BCN)') {
            multiModePriceFields = [
               {
                  label: 'leg Type',
                  value: lineItem.legName
               },
               {
                  label: 'Provider',
                  value: lineItem.providerName
               },
               {
                  label: 'Ceiling Price',
                  value: lineItem.qbr
               },
               {
                  label: lineItem.legBudget ? 'Budget' : 'Market Rate',
                  value: lineItem.legBudget ?  lineItem.legBudget : lineItem.marketrate
               },
               {
                  label: 'LPP',
                  value: lineItem.lpp
               },
            ]
         }
      }
      
      const detailsFields = [
         {
            label: 'Trip',
            value: <span>
               {lineItem.ftlStops.map((stop, index) => {
                  return (
                     <span> {((stop.location || '').split(',') || [])[0] || stop.city || ''} {stop.pincode && `(${stop.pincode})`}
                        {index !== lineItem.stops.length - 1 && <>{lineItem.multiple_route_distance.length > 0 ?
                        <div className="wt-40 inBlock tCenter">
                           <span className="wt-30 fs-12">{lineItem.multiple_route_distance[index][`distance${index +  1}`]} {'km'}</span>
                           <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />
                        </div>
                        : <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />}</>
                        } </span>
                  )
               })}
            </span>
         },
         {
            label: 'Vehicle',
            value: <span> {lineItem.vehicleTypeName} <span className="fRegular"> {lineItem.vehicleBodyTypeName} </span>  </span>
         },
         {
            label: 'Vehicle Body Type',
            value: lineItem.vehicleBodyTypeName

         },
         {
            label: 'Vehicle Remarks',
            value: lineItem.remarks,
         },
         {
            label: 'Business Volume',
            value: businessVolVal + ' ' + businessVolUnit
         },
         {
            label: 'Expected TAT',
            value: tatVal + ' ' + tatUnit
         },
         {
            label: 'Placement Time',
            value: lineItem.placementTimeFormatted
         },

         {
            label: 'Bidding',
            value: fromDate + toDate
         },
         {
            label: 'Payment Terms',
            value: PAYMENT_TERMS[lineItem.biddingDetails.paymentTerms]
         },
         {
            label: 'Payment Cycle',
            value: lineItem.biddingDetails.paymentCycleName || lineItem.paymentCycleName || ((paymentCycles || []).find((cycle) => cycle.value == lineItem.biddingDetails.paymentCycle) || {}).name || rfq.biddingDetails.paymentCycleName
         },
         {
            label: 'Pricing Basis',
            value:  lineItem.biddingDetails.pricingBasisName || lineItem.pricingBasisName || ((pricingBasis || []).find((basis) => { return basis.value === lineItem.biddingDetails.pricingBasis }) || {}).name || rfq.biddingDetails.pricingBasisName
         },
         // {
         //    label: 'CI No.',
         //    value: lineItem.biddingDetails.cinNo
         // },
         // {
         //    label: 'Job No',
         //    value: lineItem.biddingDetails.jobNo
         // },
         {
            label: 'Seeker Remarks',
            value: lineItem.seekerRemarks ? lineItem.seekerRemarks : '',
         },
         {
            label: 'Provider Remarks',
            value: lineItem.providerRemarks ? lineItem.providerRemarks : '',
         },
      ];
      if(DEEPAK_PHENOLICS.includes(rfq.companyId)){
         lineItem.vehicleSpecification.map((data) => {
         return (
            detailsFields.push({label: `Vehicle ${data.dph_type_name}`, value: data.name})
         )
      })}
      
      return (
         <div className="pl-30 pt-25 pr-25 pb-40 wt-100p border-light box-shadow mt-10">
            <span className="section-header-color fBold  fs-18 flex flex-between">
               <span>{lineItem.from} 
      { lineItem.to && <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />} {lineItem.to}</span>
               {
                  openLineItem && <span className="overlay-close-button fs-20 curP" onClick={hideLineItem}>
                     X
                            </span>
               }
            </span>
            {lineItem.rfqType !== 6 ? 
            <div className="flex mt-10 pl-30 flex-between">
               <div className="flex-column mr-30 ht-350 overflowAuto">
                  <section className="flex mt-25 flex-column">
                     <span className="section-sub-header-color fBold fs-16">
                        Details
                            </span>
                     {
                        detailsFields.map((field, index) => {
                           if(['Payment Terms', 'Payment Cycle'].includes(field.label) && CARGIL.includes(rfq.companyId) && getCompanyType() === PROVIDER_VALUE) {
                              return;
                           }
                           return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                              <div className="wt-150">
                                 <span className="section-sub-header-color fs-14">
                                    {field.label}
                                 </span>
                              </div>
                              <div className="flex-1 wt-300">
                                 <span className="header-dark-color fBold fs-14 ">
                                    {field.value}
                                 </span>
                              </div>
                           </div>
                        })
                     }

                  </section>
               </div>
               <div className="flex-1 flex-column ml-20 ht-350 overflowAuto">
                  <section className="flex mt-25 flex-column">
                     {
                        !isOtherType && lineItem.rfqType == '1' && <RFQFTLTripsTable lineItem={lineItem} />
                     }
                     {
                        (lineItem.rfqType == '2' || lineItem.rfqType == '3' || lineItem.rfqType == '5') && <RFQMultiModalTripsTable handleShowCharges={this.handleShowCharges} showCharges={this.state.showCharges} leg={this.state.leg} onHCChange={this.onHCChange} pricingBasis={pricingBasis} update={this.update} lineItem={lineItem}  currencyTypes={currencyTypes}/>
                     }
                     {
                        isOtherType && lineItem.rfqType == '1' && <RFQOtherTripsTable lineItem={lineItem} />
                     }
                  </section>
               </div>
            </div> : 
            <div className="flex mt-10 pl-30 flex-between col-1">
               <div className={ClassName("flex-column mr-30 overflowAuto col-2", {
                  'ht-350': lineItem.legName !== "Yard To Yard (BCN)"
               })}>
                  <section className="flex mt-10 flex-column">
                     {
                        multiModedataFields.map((field, index) => {
                           return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                              <div className="wt-150">
                                 <span className="section-sub-header-color fs-14">
                                    {field.label}
                                 </span>
                              </div>
                              <div className="flex-1 wt-300">
                                 <span className="header-dark-color fBold fs-14 ">
                                    {field.value}
                                 </span>
                              </div>
                           </div>
                        })
                     }

                  </section>
               </div>
               <div className={ClassName("flex-column mr-30 overflowAuto col-2", {
                  'ht-350': lineItem.legName !== "Yard To Yard (BCN)"
               })}>
                  <section className="flex mt-10 flex-column">
                     {
                        multiModePriceFields.map((field, index) => {
                           return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                              <div className="wt-150">
                                 <span className="section-sub-header-color fs-14">
                                    {field.label}
                                 </span>
                              </div>
                              <div className="flex-1 wt-300">
                                 <span className="header-dark-color fBold fs-14 ">
                                    {field.value}
                                 </span>
                              </div>
                           </div>
                        })
                     }

                  </section>
               </div>
            </div>
            }
            {/* {lineItem.rfqType === 5 && HIKAL.includes(rfq.companyId) && ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true) && 
            <div className="courier-table mt-10">
              <table cellPadding={0} cellSpacing={0} width="100%">
              <thead>
                 <tr>
                    <th>Sl No.</th>
                    <th>Cargo Packing Type</th>
                    <th>No. of Units</th>
                    <th width="60">{'Length'}</th>
                    <th width="60">{'Breadth'}</th>
                    <th width="60">{'Height'}</th>
                    <th>UOM</th>
                    <th>Net Weight</th>
                    <th>Gross Weight</th>
                    <th>Volume Weight</th>
                    <th>{`Chargable Weight ${lineItem.metricSystem === 1 ? 'kgs' : 'lb'}`}</th>
                 </tr>
              </thead>
              <tbody>
                 {(lineItem.cargoParticularList || []).map((cParticular, index) =>{
                    totalChargableWeight += Number(cParticular.chargableWeight || 0);
                    totalGrossWeight += Number(cParticular.grossWeight || 0);
                    totalNetWeight += Number(cParticular.netWeight || 0);
                    totalVolumeWeight += Number(cParticular.volumeWeight || 0);
                 return(<tr>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{index + 1}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.cargoPackingType}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.quantity}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.length}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.breadth}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.height}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{(cParticular.uom || {}).name}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.netWeight}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.grossWeight}</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}>{cParticular.volumeWeight}</td>
                    <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>{cParticular.chargableWeight}</td>
                 </tr>)})}
                 <tr>
                    <td colSpan="7" style={{ 'borderBottom': '1px solid grey'}}>Total</td>
                    <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalNetWeight}</span></td>
                    <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalGrossWeight}</span></td>
                    <td style={{ 'borderBottom': '1px solid grey'}}><span>{totalVolumeWeight}</span></td>
                    <td style={{ 'borderBottom': '1px solid grey','borderRight': '1px solid grey'}}><span>{totalChargableWeight}</span></td>
                 </tr>
              </tbody>
              </table>
            </div>} */}
            {lineItem.rfqType === 6 && lineItem.legName === "Yard To Yard (BCN)" &&
               <div className="courier-table mt-10">
                  <table cellpadding="0" cellspacing="0" className="col-1">
                        <thead>
                           <tr>
                              <th></th>
                              {lineItem.freightValue.map(val => <th>{val['Charge Name']}</th>)}
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <th>Wagon Load</th>
                              {lineItem.freightValue.map(val => <td style={{ 'borderBottom': '1px solid grey'}}>{val['Wagon Load']}</td>)}
                           </tr>
                           <tr>
                              <th>Train Load</th>
                              {lineItem.freightValue.map(val => <td style={{ 'borderBottom': '1px solid grey'}}>{val['Train Load']}</td>)}
                           </tr>
                        </tbody>
                  </table>
               </div>}  
         </div>
      )
   }
}
